export default __webpack_public_path__ + "static/media/call.4d5d73fe.gif";